<template>
  <bpb-dialog :id="`shop-dialog-${shopContext.itemId}`" class-key="shop-dialog">
    <template slot="heading">
      <bpb-icon icon="i-checkmark" :decorative="true"></bpb-icon>
      <a-label
        :path="
          shopContext.amount > 1
            ? 'shop.confirmation.heading.multiple'
            : 'shop.confirmation.heading.single'
        "
        :is-visible="true"
      />
    </template>
    <template slot="content">
      <article class="shop-cart-item shop-cart-item--is-static">
        <figure class="shop-cart-item__picture">
          <slot name="picture" />
        </figure>
        <div class="shop-cart-item__content">
          <header class="shop-cart-item__header">
            <slot name="header" />
          </header>
          <figure class="shop-cart-item__picture">
            <slot name="picture" />
          </figure>
          <dl class="definition-list definition-list--width-100">
            <div class="definition-list__group">
              <dt class="definition-list__term">
                <a-label path="shop.amount" :is-visible="true">:</a-label>
              </dt>
              <dd
                class="
                  definition-list__definition
                  definition-list__definition--is-bold
                "
              >
                {{ shopContext.amount }}
              </dd>
            </div>
            <div class="definition-list__group">
              <dt class="definition-list__term">
                <a-label path="shop.price" :is-visible="true">:</a-label>
              </dt>
              <dd
                class="
                  definition-list__definition
                  definition-list__definition--is-bold
                "
              >
                <bpb-api-price-item-price
                  :item-id="shopContext.itemId"
                  :endpoint="priceEndpoint"
                />
              </dd>
            </div>
          </dl>
        </div>
      </article>
    </template>
    <template slot="footer">
      <bpb-dialog-button-close
        class="styled-button t-99"
        :target-id="`shop-dialog-${shopContext.itemId}`"
      >
        <a-label path="shop.confirmation.buttonBack" :is-visible="true" />
      </bpb-dialog-button-close>
      <slot name="footer" />
    </template>
  </bpb-dialog>
</template>

<script>
export default {
  inject: ['formContext', 'shopContext', 'priceEndpoint'],
};
</script>
